import styled from 'styled-components';

import variables from '../../../styles/variables';

interface NoBannerWrapperProps {
  tabIndex?: number;
}

export const PageWrapper = styled.div`
  background: ${variables.colorGreyLight};
  width: 100%;
  margin: 0 auto;
  padding: 16px 0 0;
`;

export const Wrapper = styled.section`
  display: flex;
  flex-direction: unset;
  align-items: center;
  max-width: 100%;
  width: 100%;
  position: relative;
  margin: 0 auto;
  padding: 0 0 24px;
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
  display: grid;
  flex-direction: row;
  flex-wrap: wrap;
  grid-template:
    'one';
  grid-template-columns: 100%;
  max-width: ${variables.defaultWidth}px;
  padding: 0 ${variables.layoutPadding}rem;

  @media screen and (max-width: 1023px) {
    padding: 0 ${variables.mobileLayoutPadding}rem;
    flex-wrap: wrap;
    flex-direction: column;
  }
`;

export const NoBannerWrapper = styled.div<NoBannerWrapperProps>`
  display: flex;
  height: 500px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: ${variables.defaultWidth}px;
  margin: 40px ${variables.layoutPadding}rem;
  padding: 40px;
  border: 3px dashed ${variables.colorGreyLight};
  @media screen and (max-width: 1023px) {
    margin: 40px ${variables.mobileLayoutPadding}rem;
  }
`;

export const NoBannerTitle = styled.h1`
  font-size: 4rem;
  text-transform: none;
  margin-bottom: 1rem;
`;

export const NoBannerText = styled.div`
  line-height: 1.25rem;
`;
